export const SERVICES = [
  {
    slug: 'motociklai',
    photo: 'moto-t.png',
    seo: {
      lt: {
        title: 'Motociklų pervežimas Kaune ir Lietuvoje | Geltonas Traliukas',
        description: 'Profesionalus motociklų pervežimas Kaune ir visoje Lietuvoje. Specializuotas tralas visų tipų motociklams – sportiniams, adventure ir scooteriams. Skambinkite 24/7.',
        h1: 'Motociklų pervežimas Kaune ir visoje Lietuvoje',
        intro: 'Teikiame profesionalias motociklų ir keturačių pervežimo paslaugas Kaune ir visoje Lietuvoje. Pervežame visų rūšių motociklus – sportinius, klasikinius, adventure ir scooter klases – saugiai ir greitai. Specializuotas tralas su tvirtinimo juostomis apsaugo jūsų motociklą transportavimo metu.'
      },
      en: {
        title: 'Motorcycle towing in Kaunas and Lithuania | Geltonas Traliukas',
        description: 'Professional motorcycle towing in Kaunas and throughout Lithuania. We transport all types of motorcycles – sports, classic, adventure and scooters – safely and quickly. Call 24/7.',
        h1: 'Motorcycle towing in Kaunas and throughout Lithuania',
        intro: 'We provide professional motorcycle and quad bike towing services in Kaunas and across Lithuania. We transport all motorcycle types – sports, classic, adventure and scooters – safely and quickly. Our tow truck is equipped with securing straps to protect your motorcycle during transport.'
      },
      ru: {
        title: 'Перевозка мотоциклов в Каунасе и по всей Литве | Geltonas Traliukas',
        description: 'Профессиональная перевозка мотоциклов в Каунасе и по всей Литве. Перевозим все виды мотоциклов – спортивные, классические, adventure и скутеры. Звоните 24/7.',
        h1: 'Перевозка мотоциклов в Каунасе и по всей Литве',
        intro: 'Оказываем профессиональные услуги по перевозке мотоциклов и квадроциклов в Каунасе и по всей Литве. Перевозим все виды мотоциклов безопасно и быстро. Специализированный эвакуатор оснащён крепёжными ремнями для защиты вашего мотоцикла при транспортировке.'
      }
    }
  },
  {
    slug: 'automobiliai',
    photo: 'auto-b-t.png',
    seo: {
      lt: {
        title: 'Lengvųjų automobilių pervežimas Kaune | Geltonas Traliukas',
        description: 'Greitas ir saugus lengvųjų automobilių pervežimas Kaune ir visoje Lietuvoje. Pervežame po avarijos, gedimo ar su žeminta važiuokle. Atvykstame per 30 min. 24/7.',
        h1: 'Lengvųjų automobilių pervežimas Kaune ir Lietuvoje',
        intro: 'Teikiame greitas ir patikimas lengvųjų automobilių pervežimo paslaugas Kaune ir visoje Lietuvoje. Pervežame automobilius po avarijos, mechaninio gedimo, taip pat žemintos važiuoklės transporto priemones. Kauno miesto ribose atvykstame vidutiniškai per 30 minučių.'
      },
      en: {
        title: 'Car towing in Kaunas and Lithuania | Geltonas Traliukas',
        description: 'Fast and safe car towing in Kaunas and throughout Lithuania. We tow after accidents, breakdowns, and lowered suspension vehicles. We arrive within 30 minutes. 24/7.',
        h1: 'Car towing in Kaunas and throughout Lithuania',
        intro: 'We offer fast and reliable car towing services in Kaunas and across Lithuania. We transport vehicles after accidents, mechanical failures, and also cars with lowered suspension. Within Kaunas city limits we arrive within an average of 30 minutes.'
      },
      ru: {
        title: 'Эвакуация легковых автомобилей в Каунасе | Geltonas Traliukas',
        description: 'Быстрая и безопасная эвакуация легковых автомобилей в Каунасе и по всей Литве. Перевозим после аварий, поломок и автомобили с заниженной подвеской. Приезжаем за 30 мин. 24/7.',
        h1: 'Эвакуация легковых автомобилей в Каунасе и Литве',
        intro: 'Оказываем быстрые и надёжные услуги эвакуации легковых автомобилей в Каунасе и по всей Литве. Перевозим транспортные средства после аварий, механических поломок, а также автомобили с заниженной подвеской. В пределах Каунаса приезжаем в среднем за 30 минут.'
      }
    }
  },
  {
    slug: 'visureigiai',
    photo: 'offroad-auto-t.png',
    seo: {
      lt: {
        title: 'Visureigių pervežimas iki 3t Kaune ir Lietuvoje | Geltonas Traliukas',
        description: 'Saugus visureigių ir SUV iki 3t pervežimas Kaune ir visoje Lietuvoje. Patikimas tvirtinimas, greitas atvykimas ir pagalba kelyje 24/7.',
        h1: 'Visureigių ir SUV pervežimas Kaune ir Lietuvoje',
        intro: 'Specializuojamės visureigių ir SUV klasės automobilių pervežime Kaune ir visoje Lietuvos teritorijoje. Pervežame transporto priemones iki 3 tonų svorio. Kiekvienas automobilis tvirtinamas patikimomis juostomis, užtikrinančiomis saugų transportavimą.'
      },
      en: {
        title: 'Off-road & SUV towing up to 3t in Lithuania | Geltonas Traliukas',
        description: 'Safe off-road vehicle and SUV towing up to 3t in Kaunas and throughout Lithuania. Secure fastening, fast arrival, and 24/7 roadside assistance.',
        h1: 'Off-road & SUV towing in Kaunas and Lithuania',
        intro: 'We specialise in off-road and SUV towing in Kaunas and across Lithuania. We transport vehicles up to 3 tonnes. Every vehicle is secured with reliable straps ensuring safe transportation to your chosen destination.'
      },
      ru: {
        title: 'Эвакуация внедорожников до 3т в Каунасе | Geltonas Traliukas',
        description: 'Безопасная перевозка внедорожников и SUV до 3т в Каунасе и по всей Литве. Надёжное крепление, быстрый приезд и помощь на дороге 24/7.',
        h1: 'Эвакуация внедорожников и SUV в Каунасе и Литве',
        intro: 'Специализируемся на перевозке внедорожников и автомобилей класса SUV в Каунасе и по всей Литве. Перевозим транспортные средства весом до 3 тонн. Каждый автомобиль надёжно крепится ремнями для безопасной транспортировки.'
      }
    }
  },
  {
    slug: 'mikroautobusai',
    photo: 'mikro-b-t.png',
    seo: {
      lt: {
        title: 'Mikroautobusų pervežimas Kaune ir Lietuvoje | Geltonas Traliukas',
        description: 'Mikroautobusų iki 3t pervežimas Kaune ir visoje Lietuvoje. Patikimas tralas keleiviniams ir kroviniams mikroautobusams. Greita pagalba kelyje 24/7.',
        h1: 'Mikroautobusų pervežimas Kaune ir visoje Lietuvoje',
        intro: 'Teikiame mikroautobusų pervežimo paslaugas Kaune ir visoje Lietuvoje. Pervežame keleivininius ir krovininius mikroautobusus, kurių svoris neviršija 3 tonų. Mūsų tralas pritaikytas saugiai ir greitai transportuoti didesnio gabarito transporto priemones.'
      },
      en: {
        title: 'Minibus towing in Kaunas and Lithuania | Geltonas Traliukas',
        description: 'Minibus towing up to 3t in Kaunas and throughout Lithuania. Reliable tow truck for passenger and cargo minibuses. Fast 24/7 roadside assistance.',
        h1: 'Minibus towing in Kaunas and throughout Lithuania',
        intro: 'We provide minibus towing services in Kaunas and across Lithuania. We transport passenger and cargo minibuses up to 3 tonnes. Our tow truck is equipped to handle larger vehicles safely and efficiently.'
      },
      ru: {
        title: 'Эвакуация микроавтобусов в Каунасе | Geltonas Traliukas',
        description: 'Перевозка микроавтобусов до 3т в Каунасе и по всей Литве. Надёжный эвакуатор для пассажирских и грузовых микроавтобусов. Быстрая помощь 24/7.',
        h1: 'Эвакуация микроавтобусов в Каунасе и Литве',
        intro: 'Оказываем услуги по эвакуации микроавтобусов в Каунасе и по всей Литве. Перевозим пассажирские и грузовые микроавтобусы весом до 3 тонн. Наш эвакуатор приспособлен для безопасной и эффективной транспортировки крупногабаритных транспортных средств.'
      }
    }
  },
  {
    slug: 'kita-technika',
    photo: 'other-b-t.png',
    seo: {
      lt: {
        title: 'Statybinės technikos pervežimas Kaune ir Lietuvoje | Geltonas Traliukas',
        description: 'Statybinės ir žemės ūkio technikos iki 3t pervežimas Kaune ir Lietuvoje. Miniekskavatoriaus, krautuvo ar kitos technikos transportavimas. Skambinkite 24/7.',
        h1: 'Statybinės ir kitos technikos pervežimas Kaune',
        intro: 'Pervežame statybinę ir žemės ūkio techniką Kaune ir visoje Lietuvoje. Transportuojame miniekskavatoriukus, krautuvus, mini traktoriukus ir kitą techniką, kurios svoris neviršija 3 tonų. Jei nesate tikri, ar galime pervežti jūsų techniką – tiesiog paskambinkite.'
      },
      en: {
        title: 'Construction machinery transport in Kaunas | Geltonas Traliukas',
        description: 'Construction and agricultural machinery transport up to 3t in Kaunas and Lithuania. Mini excavators, loaders, tractors and more. Call us 24/7.',
        h1: 'Construction & other machinery transport in Kaunas',
        intro: 'We transport construction and agricultural machinery in Kaunas and across Lithuania. We handle mini excavators, loaders, mini tractors, and other equipment up to 3 tonnes. Not sure if we can move your machine? Just give us a call.'
      },
      ru: {
        title: 'Перевозка строительной техники в Каунасе | Geltonas Traliukas',
        description: 'Перевозка строительной и сельскохозяйственной техники до 3т в Каунасе и Литве. Мини-экскаваторы, погрузчики, тракторы и многое другое. Звоните 24/7.',
        h1: 'Перевозка строительной и другой техники в Каунасе',
        intro: 'Перевозим строительную и сельскохозяйственную технику в Каунасе и по всей Литве. Транспортируем мини-экскаваторы, погрузчики, мини-тракторы и другое оборудование весом до 3 тонн. Не уверены, сможем ли перевезти вашу технику? Просто позвоните нам.'
      }
    }
  },
  {
    slug: 'kroviniai',
    photo: 'other-2-b-t.png',
    seo: {
      lt: {
        title: 'Krovinių pervežimas iki 3t Kaune ir Lietuvoje | Geltonas Traliukas',
        description: 'Įvairių krovinių iki 3t pervežimas Kaune ir visoje Lietuvoje. Greitai, patikimai ir saugiai pristatome krovinius į nurodytą vietą. Skambinkite 24/7.',
        h1: 'Krovinių pervežimas iki 3t Kaune ir visoje Lietuvoje',
        intro: 'Teikiame įvairių krovinių pervežimo paslaugas Kaune ir visoje Lietuvoje. Pervežame krovinius, kurių svoris neviršija 3 tonų, į bet kurią šalies vietą. Kiekvienas krovinys tvirtinamas atsakingai, užtikrinant saugų pristatymą.'
      },
      en: {
        title: 'Cargo transport up to 3t in Kaunas and Lithuania | Geltonas Traliukas',
        description: 'Various cargo transport up to 3t in Kaunas and throughout Lithuania. Fast, reliable, and safe delivery to any destination. Call 24/7.',
        h1: 'Cargo transport up to 3t in Kaunas and Lithuania',
        intro: 'We provide cargo transport services in Kaunas and across Lithuania. We move goods up to 3 tonnes to any location in the country. Every load is secured responsibly to ensure safe delivery.'
      },
      ru: {
        title: 'Перевозка грузов до 3т в Каунасе и Литве | Geltonas Traliukas',
        description: 'Перевозка различных грузов до 3т в Каунасе и по всей Литве. Быстро, надёжно и безопасно доставим груз в нужное место. Звоните 24/7.',
        h1: 'Перевозка грузов до 3т в Каунасе и по всей Литве',
        intro: 'Оказываем услуги по перевозке различных грузов в Каунасе и по всей Литве. Перевозим грузы весом до 3 тонн в любую точку страны. Каждый груз надёжно закрепляется для обеспечения безопасной доставки.'
      }
    }
  },
  {
    slug: 'pagalba-kelyje',
    photo: 'sos-t.png',
    seo: {
      lt: {
        title: 'Pagalba kelyje Kaune ir Lietuvoje 24/7 | Geltonas Traliukas',
        description: 'Greita pagalba kelyje Kaune ir visoje Lietuvoje. Nuleido padangą, nusėdo akumuliatorius ar įvyko avarija? Atvykstame per 30 min. Skambinkite 24/7.',
        h1: 'Pagalba kelyje Kaune ir visoje Lietuvoje',
        intro: 'Teikiame greitą techninę pagalbą kelyje Kaune ir visoje Lietuvoje. Jei nuleido padangą, nusėdo akumuliatorius, neužsikuria variklis ar patyrėte avariją – skambinkite mums. Kauno mieste atvykstame vidutiniškai per 30 minučių, esant už miesto ribų – pagal atstumą.'
      },
      en: {
        title: 'Roadside assistance in Kaunas and Lithuania 24/7 | Geltonas Traliukas',
        description: 'Fast roadside assistance in Kaunas and throughout Lithuania. Flat tyre, dead battery, accident or breakdown? We arrive within 30 minutes. Call 24/7.',
        h1: 'Roadside assistance in Kaunas and throughout Lithuania',
        intro: "We provide fast technical roadside assistance in Kaunas and across Lithuania. Flat tyre, dead battery, engine that won't start, or an accident — just call us. Within Kaunas we arrive within an average of 30 minutes; outside the city it depends on the distance."
      },
      ru: {
        title: 'Помощь на дороге в Каунасе и Литве 24/7 | Geltonas Traliukas',
        description: 'Быстрая помощь на дороге в Каунасе и по всей Литве. Спустила шина, разрядился аккумулятор, авария? Приезжаем за 30 мин. Звоните 24/7.',
        h1: 'Помощь на дороге в Каунасе и по всей Литве',
        intro: 'Оказываем оперативную техническую помощь на дороге в Каунасе и по всей Литве. Спустила шина, разрядился аккумулятор, не заводится двигатель или произошла авария – звоните нам. В пределах Каунаса приезжаем в среднем за 30 минут, за городом – в зависимости от расстояния.'
      }
    }
  },
  {
    slug: '247',
    photo: '247-t.png',
    seo: {
      lt: {
        title: 'Tralas ir pagalba kelyje 24/7 Kaune | Geltonas Traliukas',
        description: 'Tralo ir pagalbos kelyje paslauga Kaune ir Lietuvoje 24 valandas per parą, 7 dienas per savaitę. Greitas atvykimas dieną ir naktį, savaitgaliais ir šventėmis.',
        h1: 'Tralas ir pagalba kelyje 24 valandas per parą',
        intro: 'Mūsų tralas ir pagalba kelyje pasiekiami 24 valandas per parą, 7 dienas per savaitę – dieną ir naktį, savaitgaliais ir valstybinių švenčių dienomis. Nesvarbu, kokiu paros metu kelyje iškyla problema, mes visada pasirengę atvykti ir padėti.'
      },
      en: {
        title: '24/7 tow truck and roadside assistance in Kaunas | Geltonas Traliukas',
        description: 'Tow truck and roadside assistance in Kaunas and Lithuania 24 hours a day, 7 days a week. Fast response day and night, weekends and public holidays.',
        h1: '24/7 tow truck and roadside assistance',
        intro: 'Our tow truck and roadside assistance are available 24 hours a day, 7 days a week — day and night, weekends and public holidays. No matter what time a problem occurs on the road, we are always ready to arrive and help.'
      },
      ru: {
        title: 'Эвакуатор и помощь на дороге 24/7 в Каунасе | Geltonas Traliukas',
        description: 'Эвакуатор и помощь на дороге в Каунасе и Литве круглосуточно, 7 дней в неделю. Быстрый выезд днём и ночью, в выходные и праздники.',
        h1: 'Эвакуатор и помощь на дороге 24 часа в сутки',
        intro: 'Наш эвакуатор и помощь на дороге доступны круглосуточно, 7 дней в неделю — днём и ночью, в выходные и праздничные дни. Независимо от того, в какое время суток возникла проблема, мы всегда готовы приехать и помочь.'
      }
    }
  }
];

export function findService(slug) {
  return SERVICES.find(s => s.slug === slug) || null;
}
